const USER_INFO_JWT_TOKEN_COOKIE_NAME = 'jwt'
const USER_INFO_COOKIE_NAME = 'userInfo'
const HBUS_ANONYMOUS_ID_COOKIE_NAME = 'hbus_anonymousId'
const TENANT = 'tenant'

export {
  USER_INFO_JWT_TOKEN_COOKIE_NAME,
  HBUS_ANONYMOUS_ID_COOKIE_NAME,
  USER_INFO_COOKIE_NAME,
  TENANT
}
